import { gql } from '@apollo/client';

// TODO: once the backend with the `deploymentInfo` field (see src/server/typedefs.ts in
// SP3Backend) is deployed and reachable, run `yarn codegen` and switch Topbar.tsx to the
// generated `DeploymentInfoQuery` type from '../__gqltypes__' instead of DeploymentInfoResult
// below — codegen introspects a live schema, so it can't pick up a field that isn't deployed
// anywhere yet.
export type DeploymentInfoResult = {
  deploymentInfo: {
    branch: string;
    commit: string;
    build: string;
  };
};

export const DEPLOYMENT_INFO_QUERY = gql`
  query DeploymentInfo {
    deploymentInfo {
      branch
      commit
      build
    }
  }
`;
